<template>
  <div>
    <Table :show-header='false' :columns="columns" :data="row" id="tableBorder" :width='1491'></Table>
  </div>
</template>
<script>
export default {
  props: {
      row: Array
  },
  data () {
    return {
      columns: [
         {
          title: "操作",
          align: "center",
          width: 100
        },
        {
          title: "管家id",
          align: "center",
          key: "cleanerId",
          width: 80
        },
        {
          title: "管家姓名",
          align: "center",
          key: "userName",
          width: 100
        },
        {
          title: "管家号码",
          align: "center",
          key: "cleanerAccount",
          width: 150
        },
        {
          title: "管家城市",
          align: "center",
          key: "associatedCityName",
          width: 120
        },
        {
          title: "物品id",
          align: "center",
          key: "goodsId",
          width: 80
        },
        {
          title: "物品名称",
          align: "center",
          key: "goodsName",
          width: 130
        },
        {
          title: "物料编号",
          align: "center",
          key: "stockNumber",
          width: 130
        },
        {
          title: "一级类别",
          align: "center",
          key: "goodsCatalog",
          width: 100,
          render: (h, params) => {
            const status = [
              "",
              "个护用品",
              "布草",
              "家电",
              "家具 ",
              "家居装饰",
              "其他",
            ][params.row.goodsCatalog];
            return h("span", {}, status);
          }
        },
        {
          title: "规格",
          align: "center",
          key: "goodsDesc",
          width: 100
        },
        // {
        //   title: "期初单价（元）",
        //   align: "center",
        //   key: "beginPrice",
        //   width: 100,
        //   render: (h, params) => {
        //     const beginPrice = params.row.beginPrice
        //       ? (params.row.beginPrice / 100).toFixed(2)
        //       : 0;
        //     return h("span", beginPrice);
        //   }
        // },
        {
          title: "期初数量",
          align: "center",
          key: "beginNum",
          width: 100
        },
        // {
        //   title: "期初金额（元）",
        //   align: "center",
        //   key: "beginMoney",
        //   width: 100,
        //   render: (h, params) => {
        //     const beginMoney = params.row.beginMoney
        //       ? (params.row.beginMoney / 100).toFixed(2)
        //       : 0;
        //     return h("span", beginMoney);
        //   }
        // },
        // {
        //   title: "入库单价（元）",
        //   align: "center",
        //   key: "storageUnitPrice",
        //   width: 100,
        //   render: (h, params) => {
        //     const storageUnitPrice = params.row.storageUnitPrice
        //       ? (params.row.storageUnitPrice / 100).toFixed(2)
        //       : 0;
        //     return h("span", storageUnitPrice);
        //   }
        // },
        {
          title: "入库数量",
          align: "center",
          key: "storageNum",
          width: 100
        },
        // {
        //   title: "入库金额（元）",
        //   align: "center",
        //   key: "storageMoney",
        //   width: 100,
        //   render: (h, params) => {
        //     const storageMoney = params.row.storageMoney
        //       ? (params.row.storageMoney / 100).toFixed(2)
        //       : 0;
        //     return h("span", storageMoney);
        //   }
        // },
        // {
        //   title: "出库单价（元）",
        //   align: "center",
        //   key: "outboundPrice",
        //   width: 100,
        //   render: (h, params) => {
        //     const outboundPrice = params.row.outboundPrice
        //       ? (params.row.outboundPrice / 100).toFixed(2)
        //       : 0;
        //     return h("span", outboundPrice);
        //   }
        // },
        {
          title: "出库数量",
          align: "center",
          key: "outboundNum",
          width: 100
        },
        // {
        //   title: "出库金额（元）",
        //   align: "center",
        //   key: "outboundMoney",
        //   width: 100,
        //   render: (h, params) => {
        //     const outboundMoney = params.row.outboundMoney
        //       ? (params.row.outboundMoney / 100).toFixed(2)
        //       : 0;
        //     return h("span", outboundMoney);
        //   }
        // },
        // {
        //   title: "期末单价（元）",
        //   align: "center",
        //   key: "endPrice",
        //   width: 100,
        //   render: (h, params) => {
        //     const endPrice = params.row.endPrice
        //       ? (params.row.endPrice / 100).toFixed(2)
        //       : 0;
        //     return h("span", endPrice);
        //   }
        // },
        {
          title: "期末数量",
          align: "center",
          key: "endNum",
          width: 100
        },
        // {
        //   title: "期末金额（元）",
        //   align: "center",
        //   key: "endMoney",
        //   width: 100,
        //   render: (h, params) => {
        //     const endMoney = params.row.endMoney
        //       ? (params.row.endMoney / 100).toFixed(2)
        //       : 0;
        //     return h("span", endMoney);
        //   }
        // }
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.expand-row{
    margin-bottom: 16px;
}
#tableBorder{
  border: 0 !important;
  tr{
    border: 0 !important;
  }
  td{
    border: 0 !important;
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table-housekeepingMaterials.vue